import { MessagesLayout } from "../components/MessagesLayout";

/**
 * The DM inbox route (/community/messages), reached from a "Messages" link on the
 * Social hub (no NEW top-level nav). It is the full-workspace two-pane messaging
 * surface with NO conversation selected:
 *   - DESKTOP — the bounded conversation rail (left) + a fill-width "Select a
 *     conversation" placeholder (right pane).
 *   - MOBILE  — the conversation list only (single column).
 *
 * Both the inbox and the thread routes are backed by the SAME `MessagesLayout`
 * (the list pane is never unmounted when a thread opens on desktop). This route
 * passes NO `activeId`, so no thread is fetched and the conversation is not marked
 * read. The layout owns the surface's single <h1> above the workspace.
 */
export function InboxPage() {
  return <MessagesLayout />;
}
